/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Type_PhraseInputs */



/**
* | output |
* | --- |
* | "Phrase" |
*
* @param {Knp_Terms_Type_PhraseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_type_phrase = /** @type {((inputs?: Knp_Terms_Type_PhraseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Type_PhraseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Phrase")
	if (locale === "de") return /** @type {LocalizedString} */ ("Phrase")
	if (locale === "it") return /** @type {LocalizedString} */ ("Frase")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фраза")
	if (locale === "es") return /** @type {LocalizedString} */ ("Frase")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("短语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレーズ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वाक्यांश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Frase")
	return /** @type {LocalizedString} */ ("Phrase")
});